/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.stacks'},
});

const StacksItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/stacks"
    title={messages.title}
  />
);

export default StacksItem;
